// extracted by mini-css-extract-plugin
export default {"status":"Pap7aP"};